import React from "react";
import { ProtectedPageContext } from "../pages/_contexts/ProtectedPageContext";
import { Card } from "./Card";
import { Flex } from "./compositeComponents/FlexHelpers";


export function StatCard(props:{header:string, value:string}):JSX.Element
{
    const ctx = React.useContext(ProtectedPageContext);

    return (
        <Card variant="outlined" style={{ minWidth: '140px', padding: '12px 16px' }}>
            <Flex flexDirection="column" alignItems="flex-start" gap={8}>
                <div style={{ fontSize:'14px', color: ctx.colors.text.state.info }}>{props.header}</div>
                <div style={{ fontSize: '24px', fontWeight: '600', lineHeight: 1.2 }}>{props.value}</div>
            </Flex>
        </Card>
    );
}